/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/recipes/r/'>.
 * /r/-фильтры рецептов + пагинация (§3.2)
 */
import { createFileRoute, notFound } from '@tanstack/react-router';
import CacheDataRoute from '../../../CacheDataRoute';
import Recipes from '@routes/Recipes';
import { getQueryClient } from '../../../providers/query';
import {
  buildRecipesListParams,
  recipesInfiniteQueryOptions
} from '@queries/index';
import { isContentNotFoundError } from '../../../api/contentNotFound';
import { assertValidListUrl } from '../../../ssrListParams';

export const Route = createFileRoute('/recipes/r/$')({
  /**
   * ЭТАП 2 — честный 404 для несуществующей страницы списка
   * (/recipes/r/page/99999) И для битых значений фильтров: бэк кидает
   * CONTENT_NOT_FOUND и на checkPageExists, и на «Нет фильтра "…"» /
   * «Нет товара из фильтра» (recipesResolver) -> notFound() -> HTTP 404 +
   * контент /404 без редиректа. Поэтому, в отличие от других списков,
   * проверяем ЛЮБУЮ страницу, а не только page > 1: битый фильтр может
   * быть и на первой. ensureInfiniteQueryData дедуплицируется с
   * root-префетчем (тот же ключ). Клиентскую навигацию не блокируем.
   */
  loader: async ({ location }) => {
    if (typeof window !== 'undefined') {
      return;
    }
    // Хвост /r/ обязан быть каноническим: чужие ключи, битые значения
    // и /r/page/1 — честный 404, см. src/ssrListParams.ts
    assertValidListUrl('recipes', location.pathname);
    const { params, page } = buildRecipesListParams(location.pathname);
    const queryClient = getQueryClient();
    const options = recipesInfiniteQueryOptions(params, page);
    // Префетч успел упасть раньше — ошибка уже в кэше, без второго запроса
    const settled = queryClient.getQueryState(options.queryKey);
    if (settled?.error) {
      if (isContentNotFoundError(settled.error)) {
        throw notFound();
      }
      return;
    }
    try {
      await queryClient.ensureInfiniteQueryData(options);
    } catch (error) {
      if (isContentNotFoundError(error)) {
        throw notFound();
      }
    }
  },
  component: () => <CacheDataRoute component={Recipes} path='/recipes/r/' />
});
